var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamaskreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.5304 3.56558-9.9937 7.42252 1.8481-4.3792z",
    fill: "#e2761b",
    stroke: "#e2761b"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e4761b",
    stroke: "#e4761b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.45963 3.56558 9.91337 7.49282-1.7577-4.4495z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.9347 20.7708-2.6616 4.0779 5.6949 1.5668 1.6372-5.5543z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.40494 20.8612 1.62712 5.5543 5.69494-1.5668-2.66167-4.0779z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.4056 13.8807-1.58697 2.4005 5.65477.2511-.2009-6.0766z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.5844 13.8808-3.9171-3.4953-.1306 6.1469 5.6447-.2511z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.727 24.8487 3.3948-1.6573-2.9328-2.29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.8682 23.1914 3.4049 1.6573-.4721-3.9473z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m21.2731 24.8488-3.4048-1.6573.2711 2.2197-.0301.9341z",
    fill: "#d7c1b3",
    stroke: "#d7c1b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.727 24.8488 3.1639 1.4965-.0201-.9341.2511-2.2197z",
    fill: "#d7c1b3",
    stroke: "#d7c1b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.9409 19.435-2.8323-.8337 1.9987-.914z",
    fill: "#233447",
    stroke: "#233447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0489 19.435.8337-1.7477 2.0088.914z",
    fill: "#233447",
    stroke: "#233447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.7269 24.8486.4822-4.0778-3.14379.0904z",
    fill: "#cd6116",
    stroke: "#cd6116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.7909 20.7708.4821 4.0778 2.6617-3.9874z",
    fill: "#cd6116",
    stroke: "#cd6116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.1815 16.2811-5.6447.2511.5223 2.9027.8336-1.7476 2.0088.914z",
    fill: "#cd6116",
    stroke: "#cd6116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.1086 18.6013 2.0088-.914.8236 1.7476.5323-2.9027-5.65473-.2511z",
    fill: "#cd6116",
    stroke: "#cd6116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.81866 16.2811 2.37034 4.6202-.0803-2.3z",
    fill: "#e4751f",
    stroke: "#e4751f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.9017 18.6013-.1005 2.3 2.3805-4.6202z",
    fill: "#e4751f",
    stroke: "#e4751f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.4734 16.5322-.5323 2.9027.6629 3.425.1506-4.5098z",
    fill: "#e4751f",
    stroke: "#e4751f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.5368 16.5322-.2712 1.8079.1205 4.5198.673-3.425z",
    fill: "#e4751f",
    stroke: "#e4751f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.059 19.4351-.6729 3.4249.4821.3315 2.9328-2.29.1005-2.3001z",
    fill: "#f6851b",
    stroke: "#f6851b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.1086 18.6014.0803 2.3001 2.9328 2.29.4821-.3315-.6629-3.4249z",
    fill: "#f6851b",
    stroke: "#f6851b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.1093 26.3453.0302-.9341-.2511-.2209h-3.7866l-.231.2209.0201.9341-3.1639-1.4965 1.1049.9039 2.2398 1.5568h3.8468l2.2498-1.5568 1.1049-.9039z",
    fill: "#c0ad9e",
    stroke: "#c0ad9e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.8682 23.1914-.4822-.3314h-2.7821l-.4821.3314-.2511 2.2197.231-.221h3.7865l.2511.221z",
    fill: "#161616",
    stroke: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.9523 11.4702.8538-4.09796-1.2756-3.80666-9.6623 7.17142 3.7163 3.1437 5.253 1.5367 1.1651-1.3559-.5022-.3616.8035-.7332-.6227-.4821.8035-.6127z",
    fill: "#763d16",
    stroke: "#763d16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.19403 7.37224.85374 4.09796-.54238.4017.80352.6127-.61268.4821.80351.7332-.50219.3616 1.15505 1.3559 5.253-1.5367 3.7162-3.1437-9.66223-7.17142z",
    fill: "#763d16",
    stroke: "#763d16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.8374 15.4175-5.2529-1.5367 1.5969 2.4005-2.3804 4.6202 3.1337-.0402h4.6705z",
    fill: "#f6851b",
    stroke: "#f6851b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.4056 13.8808-5.25302 1.5367-1.74764 5.4438h4.66039l3.12367.0402-2.37038-4.6202z",
    fill: "#f6851b",
    stroke: "#f6851b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.5367 16.5323.3315-5.7954 1.5266-4.12803h-6.7796l1.5066 4.12803.3515 5.7954.1205 1.828.0101 4.4997h2.7821l.0201-4.4997z",
    fill: "#f6851b",
    stroke: "#f6851b"
  }))));
}
export default SvgMetamaskreact;